export default __webpack_public_path__ + "static/media/flag-ossetia.6debcc3e.svg";